import React from "react";

const Header = () => {
  return (
    <h2
      style={{
        textAlign: "center",
      }}
    >
      Farsh Grill
    </h2>
  );
};

export default Header;
